import { __exportAll } from "./_virtual/_rolldown/runtime.js";
import "./order_print_state.js";
//#region src/order_print_state_helper.ts
var order_print_state_helper_exports = /* @__PURE__ */ __exportAll({ name: () => name });
function name(printState) {
	switch (printState) {
		case 0: return "Not Printing";
		case 1: return "Printing";
		case 2: return "Print Error";
		case 3: return "Print Success";
	}
}
//#endregion
export { name, order_print_state_helper_exports };

//# sourceMappingURL=order_print_state_helper.js.map